import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeployParams } from 'src/app/deployParams';
import { SiteViewConfiguration } from 'src/app/models/enums';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { ConfirmationDialogComponent } from 'src/app/ticket-manager/components/confirmation-dialog/confirmation-dialog.component';
import { EnterAmountDialogComponent } from 'src/app/ticket-manager/components/enter-amount-dialog/enter-amount-dialog.component';
import { ILoginRequestTM } from 'src/app/ticket-manager/models/requests/loginRequestTM.interface';
import { IAffiliate } from 'src/app/ticket-manager/models/user/affiliate.interface';
import { AffiliateRole } from 'src/app/ticket-manager/models/util/tmEnums';
import { AffiliateService } from 'src/app/ticket-manager/services/affiliate.service';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ticket-menager-header',
  templateUrl: './ticket-menager-header.component.html',
  styleUrls: ['./ticket-menager-header.component.less']
})
export class TicketMenagerHeaderComponent implements OnInit, OnDestroy {
  loggedUser: IAffiliate = null;
  loginParam: ILoginRequestTM = { username: '', password: '' };
  showError = false;
  errorText = '';
  isUserLoggedIn = false;
  isAccount = false;
  affiliateRoleEnum = AffiliateRole;
  private subscription: Subscription = new Subscription();
  enivroment = environment;
  siteViewConfigurationEnum = SiteViewConfiguration;
  viewConfigurations = ViewConfigurations;
  language: string;
  showHidePassword: boolean;

  constructor(
    private router: Router,
    private authenticateService: AuthenticationService,
    private storageService: StorageService,
    private loaderService: LoaderService,
    private affiliateService: AffiliateService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.subscription.add(this.authenticateService.loggedAffiliateChangedSource$.subscribe(() => this.setAffiliateOptions()));
    this.setAffiliateOptions();
    this.language = this.storageService.language;

  }

  private setAffiliateOptions(){
    this.isUserLoggedIn = this.authenticateService.isLoggedIn();
    if (this.isUserLoggedIn) {
      this.loggedUser = this.authenticateService.loggedAffiliate;
    }

    this.isAccount = this.router.url.includes('account');
  }

  selectLanguage(language: string) {
    if (this.language !== language) {
      window.history.pushState('', '', window.location.origin + '/' + language + '/#/');
      setTimeout(() => {
        location.reload();
      }, 20);

    }
  }

  login() {
    // this.router.navigate(['/account/login']);
    if (!this.loginParam.username || !this.loginParam.password) {
      this.showError = true;
      this.errorText = 'Username or password is required';
      return;
    }
    this.authenticateService.login(this.loginParam.username, this.loginParam.password).subscribe(resp => {
      if (resp.sucsses) {
        // this.router.navigate(['/account/cashiers']);
        this.isUserLoggedIn = true;
        this.loggedUser = this.storageService.affiliate;
        this.showError = false;
      } else {
        this.errorText = resp.errMsg;
        this.showError = true;
      }
    });
  }

  pressedEnter(key: number) {
    if (key === 13) {
      this.login();
    }
  }

  logout() {
    this.authenticateService.logout(true);
    this.loggedUser = null;
    this.isUserLoggedIn = false;
    this.loginParam = { username: '', password: '' };

  }
  account() {
    this.loaderService.showHideLoader(true);
    this.router.navigate(['/account']);
  }

  register() {
    this.router.navigate(['/account/register']);
  }

  ticketManager() {
  //  this.router.navigate(['/account/update-personal-info', this.loggedUser.affiliateId]);
    this.router.navigate(['/', 'account']);
  }

  resetPass() {
    this.router.navigate(['/account/reset-password']);
  }

  logOut() {
    // this.loggedUserService.logout();
  }

  addToBalance(){
    if (!ViewConfigurations.isPaystackEnabled) {
      return;
    }
    const dialogRef = this.dialog.open(EnterAmountDialogComponent, {
      data: {
        message: 'Enter amount to transfer.',
        buttonText: {
          ok: 'Transfer',
          cancel: 'Cancel',
        },
      },
      panelClass: 'custom-box'
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((returnValues: {confirmed: boolean; inputValue: number}) => {
      if (returnValues && returnValues.confirmed && returnValues.inputValue) {
        this.affiliateService.addToInitialBalance(returnValues.inputValue).subscribe(x => this.authenticateService.changebalance(x));
      }
    });
  }

  ngOnDestroy(): void {
    this.dialog.closeAll();
    this.subscription.unsubscribe();
  }

}
